import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { CatalogMetricSlugs } from "~/modules/catalog/types";
import { AssetTableRowData } from "../types";

// // // //

export const PERFORMANCE_1_MONTH_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.trailing1MonthReturnPercent,
    label: (
        <>
            1M
            <br />
            Return
        </>
    ),
    tooltip: CatalogMetricSlugs.trailing_1_month_return_percent,
    type: ColumnTypes.percentChange,
    sortsOn: AssetColumns.trailing1MonthReturnPercent,
    width: 120,
    cellValue: (item) =>
        item.isAsset && item.trailing_1_month_return_percent != null
            ? item.trailing_1_month_return_percent / 100
            : null,
};

export const PERFORMANCE_1_YEAR_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.trailing1YearReturnPercent,
    label: (
        <>
            1Y
            <br />
            Return
        </>
    ),
    tooltip: CatalogMetricSlugs.trailing_1_year_return_percent,
    type: ColumnTypes.percentChange,
    sortsOn: AssetColumns.trailing1YearReturnPercent,
    width: 120,
    cellValue: (item) =>
        item.isAsset && item.trailing_1_year_return_percent != null
            ? item.trailing_1_year_return_percent / 100
            : null,
};
